// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1282":"8afa7f57","1450":"47e86af0","7918":"a4753aea","9086":"963f27a7"}[chunkId] + ".css";
};